// extracted by mini-css-extract-plugin
module.exports = {"contained":"Button_contained__22Uy5","outlined":"Button_outlined__3Uswj","icon":"Button_icon__36xd-"};